import { useContext } from 'react'

import { ProcessDebugDetailsContext } from '../providers'

export function useProcessDebugDetailsContext() {
  const context = useContext(ProcessDebugDetailsContext)

  if (!context) {
    throw new Error(
      'useProcessDebugDetailsContext must be used within ProcessDebugDetailsProvider',
    )
  }

  return context
}
